import { render, staticRenderFns } from "./U9SRReporttable.vue?vue&type=template&id=63db10a4&scoped=true&"
import script from "./U9SRReporttable.vue?vue&type=script&lang=js&"
export * from "./U9SRReporttable.vue?vue&type=script&lang=js&"
import style0 from "./U9SRReporttable.vue?vue&type=style&index=0&id=63db10a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63db10a4",
  null
  
)

export default component.exports